// import packages
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Dropdown, Breadcrumb, Menu, Radio } from 'antd';
import InfiniteScroll from 'react-infinite-scroller';

// Import assets
import "./filter-page.scss"
import {
    ClearIcon, FilterClose,
    LocationIcon, Mobil_icon,
    ParkingIcon,
    SortArr,
} from "../../assets/images";

// Import Components
import HouseCard from "../../components/cards/HouseCard";
import { InputGroup } from "../../components/ui-elements/input-group/inputGroup";

// Import utils
import { getPropsFromState } from "../../redux/mapStateToProps";
import { GetAreas, GetBadges, FilterState, RemoveAreasList } from "../../redux/actions";
import { AREA_TYPES } from "../../constants/constants";
import { getUrlWithLocal } from "../../utils/getUrlWithLocal";
import { CustomRangeSlider, RoomCounter } from "../../components/filter/filter-components";
import { PrimaryButton } from "../../components/ui-elements/buttons/Buttons";
import { FIXED_AVAILABLE_BADGE_ID, FIXED_RESERVED_BADGE_ID } from "../../configs/variables";
import { LoadingOutlined } from "@ant-design/icons";
import MapModal from "../../components/modal/mapModal/MapModal";


function FilterPage (props) {
    const { areas, badges, initialAreaData } = props
    const location = useLocation()
    const navigate = useNavigate()
    const [block, setBlock] = useState(false)
    const [visible, setVisible] = useState(false)
    const { staticTexts } = props
    const { list, hasMore } = areas || {}

    let MIN_PRICE = initialAreaData?.minPrice || 0;
    let MAX_PRICE = Math.ceil(initialAreaData?.maxPrice / 100000) * 100000 || 9999999;
    // console.log('initialAreaData', initialAreaData);
    // console.log('MAX_PRICE', MAX_PRICE);
    let MIN_AREA = initialAreaData?.minArea || 0;
    let MAX_AREA = initialAreaData?.maxArea || 999;

    const filtersInitialValues = {
        type: '',
        roomsCount: [],
        minPrice: MIN_PRICE,
        maxPrice: MAX_PRICE,
        minArea: MIN_AREA,
        maxArea: MAX_AREA,
        statuses: [],
        floors: null,
        sort: '',
    }

    function closeModal () {
        setVisible(!visible)
    }

    const [filters, setFilters] = useState(filtersInitialValues)
    const [tempData, setTempData] = useState({
        minPrice: MIN_PRICE,
        maxPrice: MAX_PRICE,
        minArea: MIN_AREA,
        maxArea: MAX_AREA,
    })
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        // if (location?.state) {
        //     getStatusValue('600ab6e5e503271f1c8ebcd0')
        // }

        window.scrollTo(0, 0);
        const newState = {}

        if (location.state) {
            location.state.type && (newState.type = location.state.type)
            location.state.roomsCount && (newState.roomsCount = location.state.roomsCount)

            if (location.state?.minPrice || location.state?.maxPrice) {
                location.state.minPrice && (newState.minPrice = location.state.minPrice)
                location.state.maxPrice && (newState.maxPrice = location.state.maxPrice)
                setTempData({
                    ...tempData,
                    minPrice: location.state?.minPrice || tempData.minPrice,
                    maxPrice: location.state?.maxPrice || tempData.maxPrice
                })
            }
            navigate(getUrlWithLocal('/filter'), { state: null, replace: true })
        }
        changeFilterStateAndGetData(newState)

        props.GetBadges()
        return () => {
            props.RemoveAreasList();
        }
    }, [])

    //Functions
    function loadMoreItems () {
        hasMore && props.GetAreas({
            ...filters,
            offset: list.length,
            reset: false,
            MIN_PRICE,
            MAX_PRICE,
            MIN_AREA,
            MAX_AREA
        })
    }

    function getStatusValue (name) {
        const statuses = !filters?.statuses?.includes(name) ? filters?.statuses.concat(name) : filters?.statuses?.filter(item => item !== name)
        changeFilter("statuses", statuses)
    }

    function changeFilter (name, value) {
        let state;
        // console.log('changeFilter', name, value)
        if (name === "roomsCount") {
            state = {
                ...filters,
                [name]: filters?.roomsCount?.includes(value) ?
                    filters?.roomsCount?.filter(item => item !== value) :
                    [value, ...filters.roomsCount]
            }
        } else {
            state = {
                ...filters,
                [name]: value
            };
        }

        if (name === 'type') {
            state.floors = null;
        }
        changeFilterStateAndGetData(state);
    }

    const onChangePriceSlider = (values) => {
        setTempData({
            ...tempData,
            minPrice: values[0],
            maxPrice: values[1],
        })
    }

    function onAfterChangePrice (values) {
        const state = {
            ...filters,
            minPrice: values[0] !== MIN_PRICE ? values[0] : MIN_PRICE,
            maxPrice: values[1] !== MAX_PRICE ? values[1] : MAX_PRICE
        }
        changeFilterStateAndGetData(state)
    }

    const onChangeAreaSlider = (values) => {
        setTempData({
            ...tempData,
            minArea: values[0],
            maxArea: values[1],
        })
    }

    function onAfterChangeArea (values) {
        const state = {
            ...filters,
            minArea: values[0] !== MIN_AREA ? values[0] : MIN_AREA,
            maxArea: values[1] !== MAX_AREA ? values[1] : MAX_AREA
        }
        changeFilterStateAndGetData(state)
    }

    function removeFilters () {
        // setFilters(filtersInitialValues);
        setTempData({
            minPrice: MIN_PRICE,
            maxPrice: MAX_PRICE,
            minArea: MIN_AREA,
            maxArea: MAX_AREA,
        })

        changeFilterStateAndGetData(filtersInitialValues)
        // props.ResetAreasInfo()
    }

    function changeFilterStateAndGetData (state) {
        setFilters({ ...filters, ...state });

        props.GetAreas({
            ...state,
            MIN_PRICE,
            MAX_PRICE,
            MIN_AREA,
            MAX_AREA
        }).finally(() => {
            loading && setLoading(false)
        })
    }

    function checkIsFilterValueSelected () {
        let result = false;
        Object.keys(filtersInitialValues).forEach(key => {
            if (key === 'sort') {
                return;
            }
            if (key === 'roomsCount') {
                if (filters?.roomsCount?.length) {
                    result = true;
                }
                return;
            }
            if (key === 'statuses') {
                if (filters?.statuses?.length) {
                    result = true;
                }
                return;
            }
            if (filtersInitialValues[key] !== filters[key]) {
                result = true;
            }
        })
        return result;
    }

    const sortOptions = [
        { name: staticTexts?.sort_by_price_increase, id: 'price' },
        { name: staticTexts?.sort_by_price_reduction, id: '-price' },
        { name: staticTexts?.sort_by_area_increase, id: 'area' },
        { name: staticTexts?.sort_by_area_reduction, id: '-area' },
        { name: staticTexts?.sort_by_rooms_count_increase, id: 'roomsCount' },
        { name: staticTexts?.sort_by_rooms_count_reduction, id: '-roomsCount' },
    ]

    const saleCount = areas?.count - (areas?.availableCount + areas?.reservedCount)
    const badgesMenu = !!badges?.length && (
        <Menu className="statuses-dropdown">
            {badges.filter(badge => badge?.id !== FIXED_AVAILABLE_BADGE_ID)?.map((badge) => {
                return <Menu.Item key={badge.id}>
                    <div onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        getStatusValue(badge?.id)
                    }
                    }>
                        <Radio className={'house-filter-checkbox'} checked={filters?.statuses?.includes(badge?.id)}>
                            {badge?.id === FIXED_AVAILABLE_BADGE_ID ? `${badge?.title} (${areas?.availableCount && areas?.availableCount})`
                                : badge?.id === FIXED_RESERVED_BADGE_ID ? `${badge?.title} (${areas?.reservedCount && areas?.reservedCount})` : `${badge?.title} (${saleCount})`}
                        </Radio>
                    </div>
                </Menu.Item>
            })
            }
        </Menu>
    );
    const toggleMobileFilter = () => {
        setBlock(!block)
    };
    const availableBadge = badges?.find(badge => badge?.id === FIXED_AVAILABLE_BADGE_ID)

    const typesOptions = Object.values(AREA_TYPES).map(type => {
        return {
            id: type?.key,
            name: staticTexts?.[type?.title]
        }
    })

    const Options = [
        { name: 1, id: '1' },
        { name: 2, id: '2' },
        { name: 3, id: '3' },
        { name: 4, id: '4' },
        { name: 5, id: '5' },
        { name: 6, id: '6' },
        { name: 7, id: '7' },
        { name: 8, id: '8' },
    ]
    return <div className={'filter-page-wrapper'}>
        {
            window.innerWidth < 1001 ? <div className={`filter-menu-dropdown ${block ? "open" : ""}`}>
                <span className={'close-icon'} onClick={toggleMobileFilter}><FilterClose/></span>
                <div className={'filter-left'}>
                    {/*<div className={'types-wrapper'}>*/}
                    {/*    {Object.values(AREA_TYPES).map((type) => {*/}
                    {/*        return <div key={type?.key}*/}
                    {/*                    className={`floor-block ${filters?.type === type?.key ? 'active' : ''}`}*/}
                    {/*                    onClick={() => {*/}
                    {/*                        changeFilter('type', type?.key)*/}
                    {/*                    }}*/}
                    {/*        >{staticTexts?.[type?.filter_page_title]}</div>*/}
                    {/*    })}*/}
                    {/*</div>*/}
                    <div className={'drop-down-item'}>
                        <div className={'block-title'}>{staticTexts?.filter_type_title}</div>
                        <InputGroup
                            showSearch={false}
                            inputType={'select'}
                            value={filters.type || undefined}
                            name={'type'}
                            onClear={staticTexts?.filter_drop_down_all}
                            placeholder={staticTexts?.filter_type_title}
                            onChange={changeFilter}
                            options={typesOptions}/>
                    </div>
                    <div className={'rooms-count-wrapper'}>
                        <RoomCounter staticTexts={staticTexts}
                                     activeRooms={filters?.roomsCount}
                                     changeFilter={changeFilter}

                                     disabled={filters?.type === AREA_TYPES.OFFICE.key}

                        />
                    </div>
                    <div className={'filter-slider-range'}>
                        <CustomRangeSlider
                            title={staticTexts?.filter_price_title}
                            MIN_VALUE={MIN_PRICE}
                            MAX_VALUE={MAX_PRICE}
                            minValue={tempData.minPrice}
                            maxValue={tempData.maxPrice}
                            filter_from={staticTexts?.filter_from}
                            filter_to={staticTexts?.filter_to}
                            onChangeSlider={onChangePriceSlider}
                            onAfterChange={onAfterChangePrice}
                        />
                    </div>
                    <div className={'filter-slider-range'}>
                        <CustomRangeSlider
                            title={staticTexts?.filter_area_title}
                            MIN_VALUE={MIN_AREA}
                            MAX_VALUE={MAX_AREA}
                            minValue={tempData.minArea}
                            staticTexts={staticTexts}
                            maxValue={tempData.maxArea}
                            filter_from={staticTexts?.filter_from}
                            filter_to={staticTexts?.filter_to}
                            onChangeSlider={onChangeAreaSlider}
                            onAfterChange={onAfterChangeArea}
                        />
                    </div>
                    <div className={'slider-filter'}>
                        <div className={'floors-select'}>
                            <div className={'block-title'}>{staticTexts?.filter_floors_title}</div>
                            {filters?.types === 'PARKING' ?
                                <div className={'disable-input'}>
                                    <InputGroup
                                        showSearch={false}
                                        inputType={'input'}
                                        value={''}
                                        name={'floors'}
                                        disabled={true}
                                        placeholder={staticTexts?.filter_floors_title}
                                        onChange={changeFilter}
                                        options={Options}/>
                                </div> :
                                <InputGroup
                                    showSearch={false}
                                    inputType={'select'}
                                    value={filters.floors || undefined}
                                    name={'floors'}
                                    placeholder={staticTexts?.filter_floors_title}
                                    onChange={changeFilter}
                                    options={Options}/>
                            }
                        </div>
                    </div>
                    <div className={'filter-clear'}>
                        <button onClick={removeFilters}>
                            {staticTexts?.filter_clear_filters}<ClearIcon title={''}/>
                        </button>
                    </div>
                    <PrimaryButton className="filters-page-count-wrapper"
                                   loading={loading}
                                   title={<><span className={'filter_number'}>{areas?.count || 0} </span>
                                       <span
                                           className={'filters-count'}>{staticTexts?.filter_rooms_total}</span></>}
                                   cb={() => {
                                       setBlock(!block)
                                   }}
                    />
                </div>
            </div> : ''
        }
        <div className={'breadcrumb-wrapper'}>
            <Breadcrumb>
                <Breadcrumb.Item>
                    <Link
                        to={getUrlWithLocal('/home')}>
                        {staticTexts?.rout_item_home}
                    </Link>
                </Breadcrumb.Item>
                {/*     {buildingSlug && <Breadcrumb.Item>
                    <Link
                        to={getUrlWithLocal('/buildings')}>
                        {`${staticTexts?.rout_item_building} ${BUILDINGS_KEYS[buildingSlug]}`}
                    </Link>
                </Breadcrumb.Item>}
                {floor && <Breadcrumb.Item>
                    <Link to={getUrlWithLocal(`/floor/${floor}`)}>
                        {`${staticTexts?.rout_item_title_floor} ${floor}`}
                    </Link>
                </Breadcrumb.Item>}*/}
                <Breadcrumb.Item>
                    {staticTexts?.rout_item_filter_title}
                </Breadcrumb.Item>
            </Breadcrumb>
            <div className={'navigation-wrapper'}>
                {/*<Link to={getUrlWithLocal('/floor/-1')} className={'item-card'}>*/}
                {/*    <div className={'icon-wrapper'}>*/}
                {/*        <ParkingIcon/>*/}
                {/*    </div>*/}
                {/*</Link>*/}
                <div onClick={() => setVisible(true)} className={'item-card'}>
                    <div className={'icon-wrapper'}>
                        <LocationIcon/>
                    </div>
                </div>
            </div>
        </div>
        <div className={`mobile-wrapper`}>
            <div className={'mobil-block'} onClick={toggleMobileFilter}>
                <Mobil_icon/>
                <span>{staticTexts?.filter_title}</span>
            </div>
        </div>
        <div className={'page-content-wrapper'}>
            <div className={'filter-left'}>
                {/*<div className={'types-wrapper'}>*/}
                {/*    {Object.values(AREA_TYPES).map((type) => {*/}
                {/*        return <div key={type?.key}*/}
                {/*                    className={`floor-block ${filters?.type === type?.key ? 'active' : ''}`}*/}
                {/*                    onClick={() => {*/}
                {/*                        changeFilter('type', type?.key)*/}
                {/*                    }}*/}
                {/*        >{staticTexts?.[type?.filter_page_title]}</div>*/}
                {/*    })}*/}
                {/*</div>*/}
                <div className={'drop-down-item'}>
                    <div className={'block-title'}>{staticTexts?.filter_type_title}</div>
                    <InputGroup
                        showSearch={false}
                        inputType={'select'}
                        value={filters.type || undefined}
                        name={'type'}
                        onClear={staticTexts?.filter_drop_down_all}
                        placeholder={staticTexts?.filter_type_title}
                        onChange={changeFilter}
                        options={typesOptions}/>
                </div>
                <div className={'rooms-count-wrapper'}>
                    <RoomCounter staticTexts={staticTexts}
                                 activeRooms={filters?.roomsCount}
                                 changeFilter={changeFilter}
                                 disabled={filters?.type === AREA_TYPES.OFFICE.key}
                    />
                </div>
                <div className={'filter-slider-range'}>
                    <CustomRangeSlider
                        title={staticTexts?.filter_price_title}
                        MIN_VALUE={MIN_PRICE}
                        MAX_VALUE={MAX_PRICE}
                        minValue={tempData.minPrice}
                        maxValue={tempData.maxPrice}
                        filter_from={staticTexts?.filter_from}
                        filter_to={staticTexts?.filter_to}
                        onChangeSlider={onChangePriceSlider}
                        onAfterChange={onAfterChangePrice}
                    />
                </div>
                <div className={'filter-slider-range'}>
                    <CustomRangeSlider
                        title={staticTexts?.filter_area_title}
                        MIN_VALUE={MIN_AREA}
                        staticTexts={staticTexts}
                        MAX_VALUE={MAX_AREA}
                        minValue={tempData.minArea}
                        maxValue={tempData.maxArea}
                        filter_from={staticTexts?.filter_from}
                        filter_to={staticTexts?.filter_to}
                        onChangeSlider={onChangeAreaSlider}
                        onAfterChange={onAfterChangeArea}
                    />
                </div>
                <div className={'slider-filter'}>
                    {/*<div className={'floors-select'}>*/}
                    {/*    <div className={'block-title'}>{staticTexts?.filter_floors_title}</div>*/}
                    {/*    <InputGroup*/}
                    {/*        disabled={filters?.type === AREA_TYPES.PARKING.key}*/}
                    {/*        showSearch={false}*/}
                    {/*        inputType={'select'}*/}
                    {/*        value={filters.floors || undefined}*/}
                    {/*        name={'floors'}*/}
                    {/*        placeholder={staticTexts?.filter_floors_title}*/}
                    {/*        onChange={changeFilter}*/}
                    {/*        options={Options}/>*/}

                    {/*</div>*/}
                </div>
                <div className={`filter-clear ${checkIsFilterValueSelected() ? "show-remove-btn" : ''}`}>
                    <button onClick={removeFilters}>
                        {staticTexts?.filter_clear_filters}<ClearIcon title={''}/>
                    </button>
                </div>
                <PrimaryButton className="filters-page-count-wrapper"
                               loading={loading}
                               title={<><span className={'filter_number'}>{areas?.count || 0} </span>
                                   <span className={'filters-count'}>{staticTexts?.filter_rooms_total}</span></>}
                               cb={() => {
                               }}
                />
            </div>
            <div className={'filter-right'}>
                <div className={'filters'}>
                    <div className={'filter-top'}>
                        <div className={"filters-sort-part"}>
                            <div className={'status-sort'}>
                                <Dropdown overlay={badgesMenu}
                                          trigger={['click']}
                                          overlayClassName={'statuses-wrapper'}
                                          placement="bottomLeft"
                                          size={'small'}>
                                    <div className={"dropdown-btn"}>
                                        <div>
                                            <Radio className={'filter-page-house-filter-checkbox'} onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation()
                                                getStatusValue(availableBadge?.id)
                                            }}
                                                   checked={filters?.statuses?.includes(availableBadge?.id)}
                                            />{availableBadge && `${availableBadge?.title} (${areas?.availableCount && areas?.availableCount})`}
                                        </div>
                                        <SortArr className={'status-sort-icon'}/>
                                    </div>
                                </Dropdown>
                            </div>
                            <div className={'sort'}>
                                <InputGroup
                                    showSearch={false}
                                    inputType={'select'}
                                    // value={filterState?.sort}
                                    name={'sort'}
                                    placeholder={staticTexts?.filter_sort_placeholder}
                                    onChange={changeFilter}
                                    options={sortOptions}/>
                            </div>
                        </div>
                    </div>
                </div>
                {loading ? <div className={'loading-wrapper'}>
                        <LoadingOutlined style={{ fontSize: 40, color: "#000" }}/>
                    </div> :
                    <div className="houses-wrapper">
                        {areas?.count === 0 ?
                            <div className={'not-found'}>
                                {staticTexts?.filter_not_found}
                            </div> :
                            <InfiniteScroll
                                hasMore={hasMore}
                                loadMore={loadMoreItems}
                                className={'houses-list'}
                                pageStart={0}
                                threshold={500}
                                initialLoad={false}>
                                {!!list?.length && list.map(house => {
                                    return <div className={'cards-wrapper'}>
                                        <HouseCard house={house} key={house?.id}/>
                                    </div>
                                })}
                            </InfiniteScroll>
                        }
                    </div>}
            </div>
        </div>
        {
            visible && <MapModal closeModal={closeModal}
                                 visible={visible}/>
        }
    </div>
}

const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'initialAreaData',
    'areas',
    'badges',
    'buildings',
    'clear',
    'filterState',
]);

const mapDispatchToProps = {
    GetAreas,
    GetBadges,
    FilterState,
    RemoveAreasList
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterPage);
